import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=e97585e4&scoped=true"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=e97585e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97585e4",
  null
  
)

export default component.exports